import { apiFetch } from '../lib/api';
import type { SpotResponse, SpotMineResponse, SpotDashboardResponse } from '../types/api';
import type { SpotOutlookResponse } from '../types/weather';

export function listSpots(): Promise<SpotResponse[]> {
  return apiFetch<SpotResponse[]>('/api/spots');
}

export function listMySpots(): Promise<SpotMineResponse[]> {
  return apiFetch<SpotMineResponse[]>('/api/spots/mine');
}

export function getSpotDashboard(id: number): Promise<SpotDashboardResponse> {
  return apiFetch<SpotDashboardResponse>(`/api/spots/${id}/dashboard`);
}

export function getSpotOutlook(id: number): Promise<SpotOutlookResponse> {
  return apiFetch<SpotOutlookResponse>(`/api/spots/${id}/outlook`);
}
